<template>
  <pagetable ref="table" :data="data" @row-click="onRowClick" current-row-mode
    @current-row-change="handleCurrentRowChange" :pagination="pagination" @update:pagination="onUpdatePagination"
    size="small" :pagination-teleported="false" :pagination-show-jumber="false">
    <slot></slot>
  </pagetable>
</template>
<script setup lang="ts">
import Pagetable from '../Pagetable'
import { useLov } from '../Input'
import { ref, useTemplateRef, watch } from 'vue'
import { findIndex } from 'lodash-es'

defineOptions({ name: 'OLovPagetable', inheritAttrs: true })

const { data, pagination } = defineProps<{
  data: any[]
  pagination: {
    currentPage?: number
    pageSize?: number
    total?: number
  }
}>()

const emits = defineEmits(['update:pagination'])
const onUpdatePagination = (data: any) => {
  emits('update:pagination', data)
}

const tableRef = useTemplateRef('table')
const currentRowIndex = ref()
const currentRowData = ref()

const lov = useLov()!
lov.registerKeydownHandler((code) => {
  if (code == 'ArrowUp') {
    let nextRow: any
    if (currentRowIndex.value == 0) {
      nextRow = data[data.length - 1]
    } else {
      nextRow = data[currentRowIndex.value - 1]
    }
    //@ts-ignore
    tableRef.value!.setCurrentRow(nextRow)
    scrollToRow(currentRowIndex.value)
  } else if (code == 'ArrowDown') {
    let nextRow: any
    if (currentRowIndex.value == data.length - 1) {
      nextRow = data[0]
    } else {
      nextRow = data[currentRowIndex.value + 1]
    }
    //@ts-ignore
    tableRef.value!.setCurrentRow(nextRow)
    scrollToRow(currentRowIndex.value)
  } else if (code == 'Enter') {
    currentRowData.value && lov?.backfill(currentRowData.value)
  } else if (code == 'ArrowLeft') {
    const currentPage = pagination?.currentPage
    const pageSize = pagination?.pageSize
    const total = pagination?.total
    if (!currentPage || !pageSize || !total) {
      return
    }
    if (currentPage > 1) {
      emits('update:pagination', {
        ...pagination,
        currentPage: currentPage - 1,
      })
    }
  } else if (code == 'ArrowRight') {
    const currentPage = pagination?.currentPage
    const pageSize = pagination?.pageSize
    const total = pagination?.total
    if (!currentPage || !pageSize || !total) {
      return
    }
    const totalPage = Math.ceil(total / pageSize)
    if (currentPage < totalPage) {
      emits('update:pagination', {
        ...pagination,
        currentPage: currentPage + 1,
      })
    }
  }
})

const scrollToRow = (index: number) => {
  const $table = tableRef.value!.$el
  const $row = $table.querySelectorAll('.el-table__row')[index]
  $row.scrollIntoViewIfNeeded()
}

const onRowClick = (row: any) => {
  lov?.backfill(row)
}

const handleCurrentRowChange = (row: any) => {
  const index = findIndex(data, row)
  if (index == -1) {
    currentRowIndex.value = 0
    currentRowData.value = data[0]
  } else {
    currentRowIndex.value = index
    currentRowData.value = row
  }
}

watch(
  () => data,
  () => {
    if (data.length > 0) {
      //@ts-ignore
      tableRef.value!.setCurrentRow(data[0])
    }
  }
)
</script>
